import { DESCRIPTION_COPY_LIMITS, TITLE_COPY_LIMITS } from "../copy-policy";
export const textHeroSchema = {
    componentId: "TextHero",
    scalarSlots: [
        { key: "eyebrow", label: "Eyebrow", type: "text" },
        { key: "title", ...TITLE_COPY_LIMITS, label: "Title", type: "text" },
    ],
    mediaSlots: [],
    documentSlots: [
        { key: "description", ...DESCRIPTION_COPY_LIMITS, label: "Description" },
    ],
};
//# sourceMappingURL=text-hero.js.map